export default {
  emptyFormation: ({ formations }) => formations.length === 0,
  hasFormations: ({ formations }) => formations.length > 0 || false,
  formations: ({ formations }) =>
    formations.map((formation) => {
      if (formation.grade === null || formation.grade === undefined)
        formation.grade = "";

      return formation;
    }),
};
